<template>
  <div class="check-list-person auto-list_col_centered">
    <div
      v-if="contragentId && contragentName && !contragentPhoneMatch"
      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
    >
      <p class="text-finded">По ИНН найден</p>
      <p class="check-list-phone grey">
        {{ shortIP(contragentName) }}
      </p>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0;
        "
      >
        <div
          v-if="allowActive"
          style="margin-right: 5px"
          @click.stop="$emit('openModalPhone')"
        >
          <p class="date status">Редактировать</p>
        </div>
        <div
          v-if="!userOrgMasterApproved && allowActive"
          style="margin-left: 5px"
          @click.stop="orgApprove"
        >
          <p class="date status">Подтвердить</p>
        </div>
      </div>
    </div>
    <div
      v-if="contragentId && contragentName && contragentPhoneMatch"
      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
    >
      <p class="check-list-phone grey">
        {{ shortIP(contragentName) }}
      </p>
      <div
        v-if="!userOrgMasterApproved && allowActive"
        @click.stop="orgApprove"
      >
        <p class="date status">Подтвердить</p>
      </div>
    </div>
    <div
      v-if="
        !contragentPhoneMatch &&
        !contragentId &&
        !contragentName &&
        organizationName
      "
      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
    >
      <p class="text-finded">Не найден</p>
      <p class="check-list-phone grey">
        {{ shortIP(contragentName) || shortIP(organizationName) }}
      </p>
      <div
        v-if="!userOrgMasterApproved && allowActive"
        @click.stop="$emit('openModalContragent')"
      >
        <p class="date status success">Добавить</p>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { errHandler } from '@/helpers/errorHandler'
import { mapMutations } from 'vuex'

const Approvements = RepositoryFactory.get('approvements')

export default {
  name: 'Carrier',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    allowActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: null,
      contragentId: null,
      contragentName: null,
      organizationName: null,
      contragentPhoneMatch: false,
      userOrgMasterApproved: false,
    }
  },
  watch: {
    response: {
      handler(val) {
        this.contragentPhoneMatch = val['contragent_phone_match']
        this.userOrgMasterApproved = Boolean(val['user_org_master_approved'])
        this.id = val.id
        this.contragentId = val['contragent_id']
        this.organizationName = val['organization_name']
        this.contragentName = val['contragent_name']

        this.phone = val?.request_phone
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations({
      updateResponsesInProgress: 'loadDay/updateResponsesInProgress',
    }),
    orgApprove() {
      Approvements.postApprovements({
        create_master_approve: 1,
        link_by_rel: 'usersOrganizations',
        link_by_id: this.response?.request_user_org_id,
        status: 1,
        user_org_inn: Number(this.cur_org_inn),
      })
        .then(response => {
          if (response) {
            this.$message({
              type: 'success',
              message: 'Организация подтверждена',
              duration: 4000,
            })
            this.updateResponsesInProgress({
              user_org_master_approved: 1,
              id: this.response.id,
            })
          }
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: `Подтверждение организации не произошло. ${errHandler(
              err,
            )}`,
            duration: 4000,
          })
        })
    },
  },
}
</script>

<style lang="sass">

.text-finded
  color: #b7b7b7
  font-size: 12px!important
.buttons-wrapper
  padding: 0px
  display: flex
  justify-content: space-around
  align-items: center
  .plus-icon
    color: #d7d7d7
    transition: 0.3s
    height: 20px
    display: flex
    justify-content: flex-start
    align-items: center
    font-size: 22px
    margin-bottom: 8px
    &:hover
      color: #2ECC71
  .button-img
    padding: 0px
    cursor: pointer
    height: 20px
    background: none
    border: none
    display: flex
    justify-content: space-between
    align-items: center
    font-size: 14px
    margin-bottom: 8px
    &:hover
      background: none
    img
      margin-right: 6px
    .green
      color: #00AF37
      font-size: 18px
    .red
      color: #C21616
      font-size: 18px
    .gray
      font-size: 18px
      color: #939495

@media (max-width: 1024px)
  .buttons-wrapper
    flex-wrap: wrap
</style>
